import isArray from 'lodash/isArray';
import mergeWith from 'lodash/mergeWith';
import { AnyAction, Reducer } from 'redux';

import {
  Entity,
  EntityResponsePayload,
  isActionWithPayload,
} from '../../../store/types';

export interface EntitiesState {
  [entityType: string]: {
    [entityId: string]: Entity;
  };
}

export const initialState: EntitiesState = {};

function IsEntityPayload(payload: any): payload is EntityResponsePayload {
  return (
    (payload as EntityResponsePayload).entities !== undefined &&
    (payload as EntityResponsePayload).result !== undefined
  );
}

const entitiesReducer: Reducer<EntitiesState> = (
  state: EntitiesState = initialState,
  action: AnyAction,
) => {
  if (isActionWithPayload(action) && IsEntityPayload(action.payload)) {
    return mergeWith(
      {},
      state,
      action.payload.entities,
      (_ignored, srcValue, key) => {
        // For arrays, always replace with new value
        if (isArray(srcValue)) {
          return srcValue;
        }

        // For variable metadata, completely replace to ensure fresh data
        // This fixes the issue where old nested properties like mandatoryFacets
        // were being preserved during deep merges
        if (
          key === 'metadata' &&
          typeof srcValue === 'object' &&
          srcValue !== null
        ) {
          return srcValue;
        }

        // For other cases, use default merge behavior
        return undefined;
      },
    );
  }
  return state;
};

export default entitiesReducer;
